import {
  determineRows,
  determineCols,
  determineSubgridIdx,
  determineSubgrids,
  findValidVals,
} from "./helper";
import * as _ from "lodash";
import checker from "./sudoku-checker";

const sleep = (milliseconds) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export default function solver(
  gridVals,
  numErrorsRef = {},
  maxRecursiveCalls,
  shuffle = true
) {
  // try diff values for every 0 in the grid
  window.numRecursiveCalls++;
  // console.log(`recursive calls: ${window.numRecursiveCalls}`);
  if (window.numRecursiveCalls >= maxRecursiveCalls) {
    // console.log("reached max recursive calls");
    return true;
  }
  for (let i = 0; i < 9; i++) {
    for (let j = 0; j < 9; j++) {
      const val = gridVals[i][j];

      if (val === 0) {
        const val = gridVals[i][j];
        const rows = determineRows(gridVals);
        const cols = determineCols(gridVals);
        const subgrids = determineSubgrids(gridVals);
        const validVals = findValidVals(i, j, rows, cols, subgrids);
        let validValsShuffled;
        if (shuffle) {
          validValsShuffled = _.shuffle(validVals);
        } else {
          validValsShuffled = validVals;
        }

        // console.log(`i: ${i} j:${j} validVals: ${validVals}`);
        for (let k = 0; k < validVals.length; k++) {
          const validVal = validValsShuffled[k];
          // console.log(`i: ${i} j:${j} validVal: ${validVal}`);
          gridVals[i][j] = validVal;

          // base case bc done going through whole puzzle
          if ((i === 8) & (j === 8)) {
            // console.log("base case 1");
            const rows = determineRows(gridVals);
            const cols = determineCols(gridVals);
            const subgrids = determineSubgrids(gridVals);
            const errors = checker(rows, cols, subgrids);

            let numErrors = 0;
            Object.keys(errors).forEach((e) => {
              numErrors += errors[[e]].reduce((a, b) => a + b, 0);
            });
            numErrorsRef["errors"] = numErrors;
            // console.log("finished solver");
            return true;
          }

          let solved;
          solved = solver(gridVals, numErrorsRef, maxRecursiveCalls);
          if (solved) {
            // console.log(gridVals);
            return true;
          }
        }
        // reset val if backtracking
        gridVals[i][j] = 0;
        return false;
      } else {
        if ((i === 8) & (j === 8)) {
          // console.log("base case 2");
          gridVals[i][j] = val;
          return true;
        }
      }
    }
  }
}

export async function solverAsync(gridVals, updateGameState, delay = 250) {
  // try diff values for every 0 in the grid
  await sleep(delay);

  for (let i = 0; i < 9; i++) {
    for (let j = 0; j < 9; j++) {
      const val = gridVals[i][j];

      if (val === 0) {
        const val = gridVals[i][j];
        const rows = determineRows(gridVals);
        const cols = determineCols(gridVals);
        const subgrids = determineSubgrids(gridVals);
        const validVals = findValidVals(i, j, rows, cols, subgrids);
        const validValsShuffled = _.shuffle(validVals);

        // console.log(`i: ${i} j:${j} validVals: ${validVals}`);
        for (let k = 0; k < validVals.length; k++) {
          const validVal = validValsShuffled[k];
          // console.log(`i: ${i} j:${j} validVal: ${validVal}`);
          gridVals[i][j] = validVal;
          updateGameState(gridVals, [i, j], validVals);

          // base case bc done going through whole puzzle
          if ((i === 8) & (j === 8)) {
            const rows = determineRows(gridVals);
            const cols = determineCols(gridVals);
            const subgrids = determineSubgrids(gridVals);
            const errors = checker(rows, cols, subgrids);

            console.log("finished solver");
            updateGameState(gridVals, [], validVals);
            return true;
          }

          if (await solverAsync(gridVals, updateGameState, delay)) {
            return true;
          }
        }
        // reset val if backtracking
        gridVals[i][j] = 0;
        updateGameState(gridVals, [i, j], []);

        return false;
      } else {
        if ((i === 8) & (j === 8)) {
          gridVals[i][j] = val;
          updateGameState(gridVals, [], []);
          console.log("finished solver");
          return true;
        }
      }
    }
  }
}
